export const supportedLanguages = ["de", "en", "fr", "it"];
